
import Vue from "vue"

export default Vue.extend({
    name: "UnsavedChangesDialog",
    props: ["show", "title", "text"]
});
